import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import VotingRadioButtonsSearchField from 'components/pure/search/VotingRadioButtonsSearchField';
import VotingRadioButtonsSearchFieldStore from 'stores/search/voting/VotingRadioButtonsSearchFieldStore';
import VotingRadioButtonsSearchFieldActions from 'actions/search/VotingRadioButtonsSearchFieldActions';

class VotingRadioButtonsSearchFieldContainer extends React.Component {
  static getStores() {
    return [VotingRadioButtonsSearchFieldStore];
  }

  static getPropsFromStores() {
    return {
      store: VotingRadioButtonsSearchFieldStore.getState(),
    };
  }

  componentDidMount() {
    setTimeout(() => {
      VotingRadioButtonsSearchFieldActions.fetchTeams();
      VotingRadioButtonsSearchFieldActions.fetchDepartments();
    }, 0);
  }

  /**
   * Render an <AltContainer/> component that wraps around an actual
   */
  render() {
    return (
      <AltContainer>
        <VotingRadioButtonsSearchField {...this.props}></VotingRadioButtonsSearchField>
      </AltContainer>
    );
  }
}

export default connectToStores(VotingRadioButtonsSearchFieldContainer);
